import { ActionIcon, Modal, Stack, Tooltip } from "@mantine/core";
import { IconFilePencil } from "@tabler/icons-react";
import React, { useState } from "react";
import AddNoteContent from "../Right/notes/AddNoteContent";
import { useLanguage } from "../../../../../../stores/LanguageStore";

const QuickAddNote = () => {
  const lang = useLanguage((s) => s.language);
  const [opened, setOpened] = useState(false);

  const handleOpen = () => {
    setOpened(true);
  };

  const handleClose = () => {
    setOpened(false);
  };

  return (
    <>
      <Tooltip label={lang.leads.add_note}>
        <ActionIcon variant="light" size={"md"} onClick={handleOpen}>
          <IconFilePencil size={16} />
        </ActionIcon>
      </Tooltip>

      <Modal
        opened={opened}
        onClose={handleClose}
        title={lang.leads.add_note}
        size={"lg"}
      >
        <Stack h={"70vh"}>
          <AddNoteContent onClose={handleClose} />
        </Stack>
      </Modal>
    </>
  );
};

export default QuickAddNote;
